import React, { useEffect } from 'react'
import { useForm, FormProvider } from "react-hook-form";
import Link from "../../../../Components/Form/Link/Link";
import FormContainer from "../../../../Components/Form/FormContainer/FormContainer";
import Heading from "../../../../Components/Form/Heading/Heading";
import Section from "../../../../Components/Section/Section";
import TextInput from "../../../../Components/Form/TextInput/TextInput";
import Button from "../../../../Components/Form/Button/Button";
import { formContent } from "./content"
import IdentityApi from "../../../../Api/IdentityApi";
import { useHistory, useLocation } from "react-router-dom";
import RadioGroup from "../../../../Components/Form/RadioGroup/RadioGroup";
import ErrorAlert from "../../../../Components/Form/ErrorAlert/ErrorAlert";
import {getResponseError} from "../../../../Api/Utils/apiUtils";
import { useDispatch } from 'react-redux';
import { verifyContestAction } from './../../../../Redux/Actions/verifyContest.action';
import { useState } from 'react';
import { ScaleLoader } from 'react-spinners';

const LoginForm = ({token}) => {
    const [isLoading, setisLoading] = useState(false)
    const {
        heading,
        userType,
        emailAddress,
        password,
        loginButton,
        forgotPasswordLink,
        signupButton
        } = formContent;
    const dispatch = useDispatch()

    useEffect(() => {
        function initContestVerify() {
            if (token) {
                dispatch(verifyContestAction(token))
            }
        }
        initContestVerify()
    }, [dispatch, token])

    const [errorMessage, setErrorMessage] = React.useState(null);
    const history = useHistory();
    const location = useLocation();
    const submitForm = async (data) => {
        setisLoading(true)
        const response = await IdentityApi.login(data);
        const apiError = getResponseError(response);
        
        if(apiError){
            setErrorMessage(apiError);
        } else {
            const userDetails = response.objectVal.userResponse;
            const { isVerify } = userDetails;
            let { from } = location.state || { from: { pathname: "/profile" } };
            if (isVerify) {
                const { userResponse } = response.objectVal
                if (userResponse.userType === "supplier") {
                    history.push("/business-profile")
                }else{
                    history.replace(from);
                }
            } else {
                history.push("/verify-otp");
            }
        }
        setisLoading(false)
    }
    const formBinding = useForm();
    const { watch, handleSubmit } = formBinding;
    watch(() => setErrorMessage(''));
    return (
        <Section>
            {
                isLoading ? 
                <div className="loading-section">
                    <ScaleLoader color={'#591EC1'} loading={isLoading} size={40} />
                </div>
                :
                <FormContainer>
                    <Heading>{heading}</Heading>
                    <ErrorAlert>{errorMessage}</ErrorAlert>
                    <FormProvider {...formBinding}>
                        <form id="login-form" onSubmit={handleSubmit(submitForm)}>
                            <RadioGroup {...userType}/>
                            <TextInput {...emailAddress}/>
                            <TextInput {...password}/>
                            <Button {...loginButton}/>
                            <Link {...forgotPasswordLink}/>
                            <Button {...signupButton}/>
                        </form>
                    </FormProvider>
                </FormContainer>
                }
        </Section>
    )
}

export default LoginForm
